import { CustomFontAwesomeIconProps } from './types'

import { faEnvelope } from '@fortawesome/pro-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

const Email = (props: CustomFontAwesomeIconProps) => <FontAwesomeIcon {...props} icon={faEnvelope} />

export default Email
